import type {
  HealthcareService,
  Location,
  Patient,
  Practitioner,
  Reference,
} from '@medplum/fhirtypes'

// Mirrors the calendar store's URL-persist envelope ({state, version} under
// ?calendar=). Field parity with CalendarState (packages/react/src/stores/calendar.ts)
// is asserted by the react-side test in packages/react/src/stores/calendar.test.ts —
// core cannot import @seen/react.
export function buildScheduleProposalCalendarUrl(args: {
  windowStart: string
  windowEnd: string
  filters: Reference<Patient | Practitioner | Location | HealthcareService>[]
}): string {
  const state = {
    viewType: 'timeGrid',
    viewHorizon: 'Week',
    windowStart: args.windowStart,
    windowEnd: args.windowEnd,
    appointmentStatuses: ['proposed', 'booked'],
    appointmentFilters: args.filters,
    aggregateCalendarFilters: [],
    showRequestAppointment: false,
    requestRequiresTransportation: false,
  }
  const params = new URLSearchParams()
  params.set('calendar', JSON.stringify({ state, version: 0 }))
  return `/calendar?${params.toString()}`
}
